module.exports = __webpack_public_path__ + "static/media/IMG_6416.ce9da7bf.JPG";